import { auth } from 'src/utils';

const CURRENT_JWT = { name: undefined };
const HEADER = {};

const updateHeaderAuthorization = (role) => {
  const jwt = auth.getToken(`jwt_${role}`);
  if (jwt) {
    HEADER.authorization = `Bearer ${jwt}`;
  }
  CURRENT_JWT.name = `jwt_${role}`;
};

const getCurrentToken = () => (CURRENT_JWT.name);

export default {
  header: HEADER,
  updateHeaderAuthorization,
  getCurrentToken,
};
